import React from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PageHeader from "./PageHeader";

/**
 * The shell for the main system's pages.
 *
 * The horizontal accounting strip that used to sit under every page header has
 * gone. Accounting is now entered from the side menu and takes the whole menu
 * over while you are in it, so it no longer needs — or wants — a row of links
 * following you around the rest of the system.
 */
export default function AppContainer(props) {
  return (
    <div className="page" style={{ overflowY: "auto" }}>
      <Sidebar />

      <div className="main-content side-content pt-0">
        <Header />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="row">
                <div className="col-lg-12">
                  <PageHeader title={props.title} />
                </div>
              </div>

              <div className="col-lg-12">{props.children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
